var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.421,
    height: 27.251,
    viewBox: "0 0 27.421 27.251",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M-1085.1,360.485l5.381,5.38a1.427,1.427,0,0,1-.081,2.006,1.424,1.424,0,0,1-2.005.08l-3.849-3.848",
    transform: "translate(1104.369 -343.326)",
    fill: "none",
    stroke: "#2699fb",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M-1086.056,346.468a10.728,10.728,0,0,1,0,15.171,10.727,10.727,0,0,1-15.171,0,10.726,10.726,0,0,1,0-15.17A10.727,10.727,0,0,1-1086.056,346.468Z",
    transform: "translate(1104.369 -343.326)",
    fill: "none",
    stroke: "#06016c",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M-1089.469,358.225a5.9,5.9,0,0,1-8.345,0",
    transform: "translate(1104.369 -343.326)",
    fill: "none",
    stroke: "#2699fb",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.9738f54e.svg";
export { ForwardRef as ReactComponent };